import { amplitudeLib } from 'freedom-shared';

export type PriceChangeParams = {
  order_id: string;
  old_amount: string;
  new_amount: string;
  difference: string;
};

export const priceChangeShown = (params: PriceChangeParams) =>
  amplitudeLib.logEvent('avfree_price_change_shown', params);

export const priceChangeClosed = (params: PriceChangeParams) =>
  amplitudeLib.logEvent('avfree_price_change_closed', params);
